import React from 'react';
import { createUseStyles } from 'react-jss';
import { Media } from '../media';
import { Outlet } from 'react-router-dom';

import MunicipalidadMenu from '../components/Menu/MunicipalidadMenu';
import MunicipalidadFooter from '../components/Footer/MunicipalidadFooter';
import './MunicipalidadLayout.css';



const useStyles = createUseStyles(
  {
    
  },
  { name: 'MunicipalidadLayout' },
);

const Content = React.memo(({ classes, children }) => (
  <div className={classes.root}>
    <Media greaterThanOrEqual="lg">
      <div className={classes.left}></div>
    </Media>
    <div className={classes.wrapper}>
      <div className={classes.top}>
      <MunicipalidadMenu></MunicipalidadMenu>

      </div>
      <div className={classes.content}>{children}</div>
      <MunicipalidadFooter></MunicipalidadFooter>
    </div>
  </div>
));

const MunicipalidadLayout = () => {
  const classes = useStyles();

  return (
    <>
      <Content classes={classes}>
            <Outlet />
          </Content>
    </>
  );
};

export default React.memo(MunicipalidadLayout);
